import React from 'react'

import KinerjaLayout from 'app/KinerjaShared/components/KinerjaLayout'
import { getServerSidePropsWithToggle } from 'utils/toggle.server'
import { TOGGLE_KEYS } from 'configs/toggle-feature'
import PageGuardPengawas from 'app/KinerjaPSPage/components/PageGuardPengawas'
import { PENGELOLAAN_KINERJA_NOT_FOUND_PATH } from 'app/KinerjaShared/constants/path'
import { PageGuardPenetapan } from 'app/KinerjaPSPage/components/PageGuardPenetapan'
import { PenetapanPredikatGuru } from 'app/KinerjaPSPage/pages/penetapan/guru/PenetapanPredikatGuru'

import type { TToggleKeyValuePair } from 'configs/toggle-feature'
import type { NextPageContext } from 'next'

export const getServerSideProps = getServerSidePropsWithToggle({
  toggleKeys: TOGGLE_KEYS.filter((key) => key.includes('kinerja')),
  serverProps: async (
    _context: NextPageContext,
    toggle: TToggleKeyValuePair
  ) => {
    const enabled =
      (toggle?.['kinerja-ps-enabled'] &&
        toggle?.['kinerja-ps-penetapan-enabled']) ||
      false

    if (!enabled) {
      return {
        redirect: {
          destination: PENGELOLAAN_KINERJA_NOT_FOUND_PATH,
          permanent: false,
        },
      }
    }
  },
})

function Page() {
  return (
    <PageGuardPengawas accessibleByKepalaDinas>
      <PageGuardPenetapan>
        <PenetapanPredikatGuru />
      </PageGuardPenetapan>
    </PageGuardPengawas>
  )
}

Page.Layout = KinerjaLayout

export default Page
